


























import {Component, Vue} from 'vue-property-decorator';
import AnimatedInput from "@/components/AnimatedInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import Browsercheck from "@/components/Browsercheck.vue";
import User from "@/models/User";
import AccountDataAES from "@/util/accountDataAES";
import AdminAdapter from "@/adapters/admin";
import Base64Encoder from "@/util/base64encoder";
import {Mutation} from "vuex-class";

@Component({
  components: { AnimatedInput, LoadingButton, Browsercheck },
})
export default class ResetPasswordForm extends Vue {

  email: string = "";
  password: string = "";
  repeat: string = "";
  adminAdapter: AdminAdapter = new AdminAdapter();

  @Mutation setLoggedIn!: ({username, hash, key, persistent}: {username: string, hash: string, key: CryptoKey, persistent: boolean}) => void;

  get nonce(): string {
    return this.$router.currentRoute.params.nonce;
  }

  async resetPassword() {

    if (this.password !== this.repeat) {
      this.$toast.error("Passwörter stimmen nicht überein.");
      return;
    }

    //Generate Keys and hashes:
    const tempAccountKey: CryptoKey | null = await AccountDataAES.generateMasterKeyFromUserPassword(this.email, this.password);
    if (!tempAccountKey) {
      throw new Error("Could not compute account key");
    }
    const tempMasterHash: string = await AccountDataAES.generateAuthenticationHashFromMasterKey(tempAccountKey, this.password);

    const accountKey: CryptoKey = await AccountDataAES.generateKey();
    const accountKeyIv: Uint8Array = AccountDataAES.generateIV();

    //EncryptAccountKeyWith password based master key:
    const aesInstance: AccountDataAES = new AccountDataAES(tempAccountKey);

    //Put everything into the user:
    const user: User = new User();
    user.email = this.email;
    user.password = tempMasterHash;
    user.accountKey = await aesInstance.wrapKey(accountKey, accountKeyIv);
    user.accountKeyIv = Base64Encoder.bytesToString(accountKeyIv);

    try {
      await this.adminAdapter.resetPassword(this.nonce, user);
      //Now Login:
      this.setLoggedIn({
        username: user.email,
        hash: tempMasterHash,
        key: accountKey,
        persistent: true,
      });

      this.$toast.success("Passwort zurückgesetzt.");
      this.$router.push("/account");
    } catch (error) {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte überprüfe deine Eingaben.");
      }
    }

  }
}
